const styles = theme => ({
	
	icon: {
		color: '#009AC9',
		cursor: 'pointer',
	},

	iconUnchecked: {
		color: '#707070',
		cursor: 'pointer',
	},
});

export default styles;